const firebaseConfig = {
    apiKey: "AIzaSyCbL550sUkZz9WCJfsLS2ACnV8oog4NrRs",
    authDomain: "sorteolabolita-75.firebaseapp.com",
    databaseURL: "https://sorteolabolita-75.firebaseio.com",
    projectId: "sorteolabolita-75",
    storageBucket: "sorteolabolita-75.appspot.com",
    messagingSenderId: "221256415331",
};

export default firebaseConfig;
